// Auto-generated by scripts/write-build-info.js — do not edit by hand.
export const BUILD_SHA = "ts-1790522640332";
export const BUILT_AT = "2026-09-27T15:24:00.332Z";
